import React from 'react';
import PropTypes from 'prop-types';

const ValidationMessage = ({ controlName, message }) => (<div><strong>{controlName}</strong> {message}</div>);

ValidationMessage.propTypes = {
    controlName: PropTypes.string.isRequired,
    message: PropTypes.node.isRequired
};

ValidationMessage.defaultProps = {
    controlName: '',
    message: null
};

export default ValidationMessage;
